import { z } from "zod";
const ShippingInfoSchema = z.object({
  courier: z.string().optional().nullable().describe("\uD0DD\uBC30\uC0AC"),
  trackingNumber: z.string().optional().nullable().describe("\uC6B4\uC1A1\uC7A5 \uBC88\uD638"),
  shippingDate: z.string().datetime({ message: "\uC720\uD6A8\uD55C \uB0A0\uC9DC/\uC2DC\uAC04 \uBB38\uC790\uC5F4\uC774\uC5B4\uC57C \uD569\uB2C8\uB2E4." }).optional().nullable().describe("\uCD9C\uACE0 \uC77C\uC790 (ISO 8601 \uD615\uC2DD)"),
  status: z.string().optional().nullable().describe("\uBC30\uC1A1 \uC0C1\uD0DC"),
  method: z.string().optional().nullable().describe("\uBC30\uC1A1 \uBC29\uBC95"),
  expectedDeliveryDate: z.string().datetime({ message: "\uC720\uD6A8\uD55C \uB0A0\uC9DC/\uC2DC\uAC04 \uBB38\uC790\uC5F4\uC774\uC5B4\uC57C \uD569\uB2C8\uB2E4." }).optional().nullable().describe("\uC608\uC0C1 \uB3C4\uCC29\uC77C (ISO 8601 \uD615\uC2DD)")
}).describe("\uBC30\uC1A1 \uC815\uBCF4");
const OrderSchema = z.object({
  orderNo: z.string().describe("\uC8FC\uBB38 \uBC88\uD638"),
  title: z.string().describe("\uC8FC\uBB38 \uC81C\uBAA9").optional().nullable(),
  orderStatus: z.string(),
  jobStatus: z.string().optional().nullable(),
  orderDate: z.string().datetime({ message: "\uC720\uD6A8\uD55C \uB0A0\uC9DC/\uC2DC\uAC04 \uBB38\uC790\uC5F4\uC774\uC5B4\uC57C \uD569\uB2C8\uB2E4." }).optional().nullable().describe("\uC8FC\uBB38 \uC77C\uC790 (ISO 8601 \uD615\uC2DD)"),
  shippingInfo: ShippingInfoSchema.optional().nullable(),
  raw: z.any().optional().nullable(),
  amount: z.number().describe("\uC8FC\uBB38 \uAE08\uC561").optional().nullable()
}).describe("\uC8FC\uBB38 \uC0C1\uC138 \uC815\uBCF4");
const GetOrderInputSchema = z.object({
  orderNo: z.string().describe("\uC870\uD68C\uD560 \uC8FC\uBB38 \uBC88\uD638")
});
const GetOrderOutputSchema = OrderSchema;
const LineItemSchema = z.object({
  productName: z.string().describe("\uC0C1\uD488\uBA85"),
  productId: z.string().describe("\uC0C1\uD488 ID"),
  category: z.string().describe("\uCE74\uD14C\uACE0\uB9AC"),
  quantity: z.number().describe("\uC218\uB7C9"),
  // price: z.number().describe('가격'),
  totalPrice: z.number().describe("\uCD1D \uAC00\uACA9"),
  weight: z.number().optional().nullable().describe("\uBB34\uAC8C"),
  raw: z.any().optional().nullable()
}).describe("\uC8FC\uBB38 \uD56D\uBAA9");
const ShippingDetailSchema = ShippingInfoSchema.extend({
  expectedDeliveryDate: z.string().datetime({ message: "\uC720\uD6A8\uD55C \uB0A0\uC9DC/\uC2DC\uAC04 \uBB38\uC790\uC5F4\uC774\uC5B4\uC57C \uD569\uB2C8\uB2E4." }).optional().nullable().describe("\uC608\uC0C1 \uBC30\uC1A1 \uC77C\uC790 (ISO 8601 \uD615\uC2DD)"),
  cost: z.number().optional().nullable().describe("\uBC30\uC1A1\uBE44"),
  address: z.string().optional().nullable().describe("\uBC30\uC1A1\uC9C0 \uC8FC\uC18C"),
  recipient: z.string().optional().nullable().describe("\uC218\uB839\uC778 \uC774\uB984"),
  phoneNumber: z.string().optional().nullable().describe("\uC218\uB839\uC778 \uC804\uD654\uBC88\uD638"),
  courier: z.string().optional().nullable().describe("\uD0DD\uBC30\uC0AC"),
  trackingNumber: z.string().optional().nullable().describe("\uC6B4\uC1A1\uC7A5 \uBC88\uD638"),
  shippingDate: z.string().datetime({ message: "\uC720\uD6A8\uD55C \uB0A0\uC9DC/\uC2DC\uAC04 \uBB38\uC790\uC5F4\uC774\uC5B4\uC57C \uD569\uB2C8\uB2E4." }).optional().nullable().describe("\uCD9C\uACE0 \uC77C\uC790 (ISO 8601 \uD615\uC2DD)"),
  status: z.string().optional().nullable().describe("\uBC30\uC1A1 \uC0C1\uD0DC"),
  method: z.string().optional().nullable().describe("\uBC30\uC1A1 \uBC29\uBC95")
}).describe("\uBC30\uC1A1 \uC0C1\uC138 \uC815\uBCF4");
const FileInfoSchema = z.object({
  filestat: z.string().optional().nullable().describe("\uD30C\uC77C \uC0C1\uD0DC"),
  name: z.string().optional().nullable().describe("\uD30C\uC77C \uC774\uB984")
});
const ReworkInfoSchema = z.object({
  jobstat: z.number().optional().nullable().describe("\uC7AC\uC791\uC5C5 \uC0C1\uD0DC"),
  jobstatname: z.string().optional().nullable().describe("\uC7AC\uC791\uC5C5 \uC0C1\uD0DC \uC774\uB984"),
  ordnum: z.string().optional().nullable().describe("\uC8FC\uBB38 \uBC88\uD638"),
  rwkreason: z.string().optional().nullable().describe("\uC7AC\uC791\uC5C5 \uC774\uC720")
});
const OrdJobSchema = z.object({
  jobtype: z.string().optional().nullable(),
  covercd: z.string().optional().nullable(),
  pagecd: z.string().optional().nullable(),
  jobno: z.number().optional().nullable(),
  jobname: z.string().optional().nullable(),
  sizeno: z.number().optional().nullable(),
  sizename: z.string().optional().nullable(),
  hsize: z.number().optional().nullable(),
  wsize: z.number().optional().nullable(),
  csize: z.number().optional().nullable(),
  paperno: z.number().optional().nullable(),
  paperrname: z.string().optional().nullable(),
  color1no: z.number().optional().nullable(),
  color1noadd: z.string().optional().nullable(),
  colorno2: z.number().optional().nullable(),
  colorno2add: z.string().optional().nullable(),
  color1name: z.string().optional().nullable(),
  color1nameadd: z.string().optional().nullable(),
  color2name: z.string().optional().nullable(),
  color2nameadd: z.string().optional().nullable(),
  optno: z.number().optional().nullable(),
  optname: z.string().optional().nullable(),
  jobqty: z.number().optional().nullable(),
  pagecnt: z.number().optional().nullable(),
  qunit: z.string().optional().nullable(),
  dcjob: z.number().optional().nullable(),
  cost: z.number().optional().nullable()
});
const OrdSubSchema = z.object({
  ordseq: z.number().optional().nullable(),
  prodno: z.number().optional().nullable(),
  prodname: z.string().optional().nullable(),
  prodgroup: z.string().optional().nullable(),
  ordqty: z.number().optional().nullable(),
  ordcnt: z.number().optional().nullable(),
  qunit: z.string().optional().nullable(),
  cost: z.number().optional().nullable(),
  costsup: z.number().optional().nullable(),
  costtax: z.number().optional().nullable(),
  dcsub: z.number().optional().nullable(),
  weight: z.number().optional().nullable(),
  awkcnt: z.number().nullable(),
  ordjob: z.array(OrdJobSchema).optional().nullable()
});
const OrderRawSchema = z.object({
  dboxnum: z.string().optional().nullable(),
  ordkey: z.string().optional().nullable(),
  dlvyno: z.number().optional().nullable(),
  jobstatval: z.string().optional().nullable(),
  rokdt: z.string().optional().nullable(),
  ordstat: z.number().optional().nullable(),
  jobstat: z.number().optional().nullable(),
  dlvystat: z.number().optional().nullable(),
  dlvcomp: z.string().optional().nullable(),
  dlvymcd: z.number().optional().nullable(),
  regdt: z.string().optional().nullable(),
  ordno: z.number().optional().nullable(),
  totcnt: z.number().optional().nullable(),
  dlvystatval: z.string().optional().nullable(),
  dboxno: z.number().optional().nullable(),
  ordtitle: z.string().optional().nullable(),
  ordnum: z.string().optional().nullable(),
  ordstatval: z.string().optional().nullable(),
  ordsub: z.array(OrdSubSchema).optional().nullable()
});
const OrderDetailSchema = OrderSchema.extend({
  orderNo: z.string().describe("\uC8FC\uBB38 \uBC88\uD638"),
  title: z.string().describe("\uC8FC\uBB38 \uC81C\uBAA9").optional().nullable(),
  orderStatus: z.string(),
  jobStatus: z.string().optional().nullable(),
  orderDate: z.string().datetime({ message: "\uC720\uD6A8\uD55C \uB0A0\uC9DC/\uC2DC\uAC04 \uBB38\uC790\uC5F4\uC774\uC5B4\uC57C \uD569\uB2C8\uB2E4." }).optional().nullable().describe("\uC8FC\uBB38 \uC77C\uC790 (ISO 8601 \uD615\uC2DD)"),
  amount: z.number().describe("\uC8FC\uBB38 \uAE08\uC561").optional().nullable(),
  items: z.array(LineItemSchema).describe("\uC8FC\uBB38 \uD56D\uBAA9 \uBAA9\uB85D"),
  shippingInfo: ShippingDetailSchema.optional().nullable().describe("\uBC30\uC1A1 \uC815\uBCF4"),
  fileInfo: FileInfoSchema.optional().nullable().describe("\uD30C\uC77C \uC815\uBCF4"),
  reworkInfo: ReworkInfoSchema.optional().nullable().describe("\uC7AC\uC791\uC5C5 \uC815\uBCF4"),
  raw: OrderRawSchema.optional().nullable()
});
export {
  FileInfoSchema,
  GetOrderInputSchema,
  GetOrderOutputSchema,
  LineItemSchema,
  OrderDetailSchema,
  OrderRawSchema,
  OrderSchema,
  ReworkInfoSchema,
  ShippingDetailSchema,
  ShippingInfoSchema
};
//# sourceMappingURL=order.js.map